<template>
	<div class="footer-terms">
		<div class="footer-terms__all-rights-reserved">
			<span class="footer-terms__text">Carfree {{ currentYear }} © {{ $t('components.footer.terms.all_rights_reserved') }}</span>
		</div>
		<div class="footer-terms__container footer-terms__container--images">
			<GlobalImage src="eu-funds.png" alt="eu-funds" :height="40" />
			<GlobalImage src="republic-of-poland.png" alt="republic-of-poland" :height="40" />
			<GlobalImage src="eu.png" alt="eu" :height="40" />
		</div>
		<div class="footer-terms__container footer-terms__container--links">
			<NuxtLink
				class="footer-terms__text"
				rel="nofollow"
				target="_blank"
				:to="getLocaleLang() === 'pl' ? '/docs/PP-PL-05.25.pdf' : '/docs/PP-EN-05.25.pdf'"
				>{{ $t('components.footer.terms.privacy_policy') }}</NuxtLink
			>
			<a
				class="footer-terms__text"
				rel="nofollow"
				target="_blank"
				:href="getLocaleLang() === 'pl' ? '/docs/R-PL-05.25.pdf' : '/docs/R-EN-05.25.pdf'"
				>{{ $t('components.footer.terms.site_terms') }}</a
			>
			<div class="footer-terms__text" rel="nofollow" target="_blank" to="#">
				<a
					class="footer-terms__text"
					rel="nofollow"
					target="_blank"
					:href="getLocaleLang() === 'pl' ? '/docs/OWU-PL-08.24.pdf' : '/docs/OWU-EN-08.24.pdf'"
					>{{ $t('components.footer.terms.contract_terms') }}</a
				>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
const { getLocaleLang } = usei18nService()
const currentYear = new Date().getFullYear()
</script>
<style scoped lang="scss">
@import './Terms';
</style>
